import React, { useRef, useState } from "react";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";

export const VideoPlayer = ({ content }) => {
    const parsed = content;
    const videoStruct = parsed.videoStruct || {};
    const caption = parsed.caption?.text || "";
    const thumbnailBase64 = videoStruct.largeThumbnail?.thumbnail || "";
    const thumbnailWidth = videoStruct.largeThumbnail?.width || 320;
    const thumbnailHeight = videoStruct.largeThumbnail?.height || 240;
    const remoteVideoUrl = videoStruct.videoFile?.remoteId || "";

    const [videoUrl, setVideoUrl] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);
    const videoRef = useRef(null);

    const handleDownload = () => {
        setIsLoading(true);
        setHasStarted(true);

        fetch(remoteVideoUrl, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_messenger_token"),
            },
        })
            .then((res) => {
                const contentLength = +res.headers.get("Content-Length");
                let received = 0;
                const reader = res.body.getReader();
                const chunks = [];

                const readChunk = () => {
                    return reader.read().then(({ done, value }) => {
                        if (done) {
                            const blob = new Blob(chunks);
                            const blobUrl = URL.createObjectURL(blob);
                            setVideoUrl(blobUrl);
                            setIsLoading(false);
                            return;
                        }
                        chunks.push(value);
                        received += value.length;
                        setProgress(Math.floor((received / contentLength) * 100));
                        return readChunk();
                    });
                };

                return readChunk();
            })
            .catch((err) => {
                console.error("Video fetch failed", err);
                setIsLoading(false);
            });
    };

    return (
        <div
            style={{
                backgroundColor: "#000",
                borderRadius: 12,
                padding: 10,
                fontFamily: "IRANSans",
                position: "relative",
                direction: "rtl",
                maxWidth: "100%",
            }}
        >
            <div
                style={{
                    position: "relative",
                    borderRadius: 10,
                    overflow: "hidden",
                    width: "100%",
                    marginBottom: 8,
                }}
            >
                {/* Thumbnail or Video */}
                {!videoUrl ? (
                    <img
                        src={`data:image/jpeg;base64,${thumbnailBase64}`}
                        alt="thumbnail"
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            maxWidth: `${thumbnailWidth}px`,
                            maxHeight: `${thumbnailHeight}px`,
                        }}
                    />
                ) : (
                    <video
                        ref={videoRef}
                        src={videoUrl}
                        controls
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            borderRadius: 12,
                            maxWidth: `${thumbnailWidth}px`,
                            maxHeight: `${thumbnailHeight}px`,
                        }}
                    />
                )}

                {/* Download Button */}
                {!videoUrl && !isLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <IconButton
                            onClick={handleDownload}
                            size="large"
                            style={{ backgroundColor: "#1976d2", color: "#fff" }}
                        >
                            <DownloadIcon fontSize="medium" />
                        </IconButton>
                    </div>
                )}

                {/* Loading State */}
                {isLoading && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: 14,
                        }}
                    >
                        {progress > 0 ? `در حال دانلود... ${progress}%` : "در حال بارگذاری..."}
                    </div>
                )}
            </div>

            {/* Caption */}
            {caption && (
                <div style={{ fontSize: 13, color: "#ccc", paddingTop: 4 }}>{caption}</div>
            )}
        </div>
    );
};
